export const dormitoryStudentQueryKeys = {
  all: ['dormitory-student'] as const,
  studentPreRegistrationSchedule: () => [...dormitoryStudentQueryKeys.all, 'pre-registration-event', 'available'] as const,
  myPreRegistrations: () => [...dormitoryStudentQueryKeys.all, 'pre-registration', 'my'] as const,
};
